// Suggestions de précision home staging adaptées au type de pièce (Visite IA + Studio).
const LIVING = ["cheminée allumée", "canapé cosy", "table basse déco", "plantes vertes", "ambiance chaleureuse", "coin lecture"];
const DINING = ["table dressée pour 6", "bougies allumées", "vaisselle élégante", "centre de table fleuri", "ambiance conviviale"];
const BEDROOM = ["lit king size", "linge de lit blanc", "plaid douillet", "ambiance cosy", "coin lecture", "lampe de chevet chaleureuse"];
const KITCHEN = ["plan de travail dressé", "fruits frais sur le comptoir", "ustensiles élégants", "petit-déjeuner servi", "plantes aromatiques"];
const BATH = ["serviettes moelleuses", "bougies parfumées", "plantes vertes", "ambiance spa", "produits de beauté élégants"];
const OFFICE = ["bureau ordonné", "bibliothèque garnie", "plante verte", "lampe design", "ambiance studieuse"];
const OUTDOOR = ["salon de jardin", "tipi avec des enfants qui jouent", "barbecue convivial", "guirlandes lumineuses", "coucher de soleil chaleureux", "transats"];
const POOL = ["transats au bord de l'eau", "eau turquoise", "ambiance estivale", "parasol et bain de soleil"];
const DEFAULT = ["ambiance chaleureuse", "plantes vertes", "lumière au coucher du soleil", "décoration soignée", "enfants qui jouent"];

const norm = (s) => (s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function suggestionsForRoom(room) {
  const r = norm(room);
  if (/piscine/.test(r)) return POOL;
  if (/(jardin|terrasse|exterieur|balcon|vue_ext|facade)/.test(r)) return OUTDOOR;
  if (/chambre/.test(r)) return BEDROOM;
  if (/cuisine/.test(r)) return KITCHEN;
  if (/(salle a manger|manger|a_manger)/.test(r)) return DINING;
  if (/(salon|sejour)/.test(r)) return LIVING;
  if (/(bain|douche|\bwc\b|sanitaire)/.test(r)) return BATH;
  if (/bureau/.test(r)) return OFFICE;
  return DEFAULT;
}
